export const GET_ALL_UTILITIES_DATA = "UTILITIES/GET_ALL_UTILITIES_DATA";
export const SAVE_UTILITIES_DATA = "UTILITIES/SAVE_UTILITIES_DATA";
